/*
 * @Author: tangke
 * @Date: 2019-03-02 18:22:52
 * @Last Modified by: others
 * @Last Modified time: 2019-03-05 16:09:19
 * 试课特有评价弹窗下的学生评价template
 */
 <template>
  <div>
    <v-card v-for="(item, index) in selectTem.filter(item => item.type === keys)"
            :key="index"
            class="mt-3">
      <v-card-actions>
        <p class="subheading teal--text text--darken-2">Template {{index+1}}</p>
        <v-spacer></v-spacer>
        <v-btn small
               color="teal"
               class="text-none white--text"
               @click="checkTemplate(item)">Select</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-textarea outline
                    ref="myinput"
                    no-resize
                    disabled
                    height="138"
                    color="purple"
                    class="body-2 normalTextarea"
                    :class="item.select ? 'active':''"
                    name="input-7-4"
                    :value="item.descripton"></v-textarea>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'remarkTemplate',
  props: {
    selectTem: {},
    // 增加keys使得切换后其他类型下的评价模板选中的话,原来的选中会失效
    keys: null
  },
  data: () => ({

  }),
  methods: {
    checkTemplate (e) {
      console.log(this.selectTem)
      this.selectTem.forEach(element => {
        element.select = false
      })
      e.select = true
    }
  }
}
</script>
<style lang="scss">
  // 修改select时候的样式
  .normalTextarea.theme--light.v-text-field--outline
    > .v-input__control
    > .v-input__slot {
    background-color: #f5f5f5 !important;
  }
  .normalTextarea.theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 0.54);
  }

  .normalTextarea.active.theme--light.v-text-field--outline
    > .v-input__control
    > .v-input__slot {
    border-color: #009688 !important;
  }
</style>
<style lang="scss" scoped>
</style>
